import { getAcademyContentPageName, handleAcademyPageNameSuccess } from '../academy/getAcademyContentPageName';
import { getSentryExtra } from '../error/getSentryExtra';
import { FlowActionTypes } from '../store/flow/action-types';
import { EndpointKey } from './EndpointKey';
import { LOG } from './HttpRequester';
export const EndpointsAcademy = {
  [EndpointKey.AcademyContentPageName]: {
    method: getAcademyContentPageName,
    handleSuccess: handleAcademyPageNameSuccess,
    handleError: error => {
      LOG.error('Track/Lesson Information Request Failed', {
        extra: getSentryExtra(error)
      });
    },
    reduxActionType: FlowActionTypes.Load
  }
};